import { useCallback, useState } from "react";

/** Shared delete-confirmation modal state for dashboard CRUD screens. */
export function useDeleteModal() {
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const open = useCallback((id) => {
    setDeleteId(id);
    setShow(true);
  }, []);

  const close = useCallback(() => {
    setShow(false);
    setDeleteId(null);
  }, []);

  return { show, deleteId, open, close };
}
